import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, TrendingDown, Activity, Scale } from 'lucide-react';
import { thematicContent } from '../data/thematicContent';
import RelatedPages from '../components/RelatedPages';
import { relatedPagesMap } from '../data/relatedPages';
import FAQ from '../components/FAQ';
import { faqMap } from '../data/faqContent';
import SEO from '../components/SEO';

const PertePoidsHormonale = () => {
  const pageData = thematicContent.pertePoidsHormonale;

  return (
    <div style={{ marginTop: '100px' }}>
      <SEO
        title={pageData.meta.title}
        description={pageData.meta.description}
        keywords={pageData.meta.keywords}
        url="https://nutricentreriviera.ch/perte-poids-hormonale"
      />
      <section style={{ background: 'var(--gradient-hero)', padding: '4rem 0', textAlign: 'center' }}>
        <div className="container">
          <h1 className="heading-hero" style={{ marginBottom: '1.5rem' }}>{pageData.h1}</h1>
          <p className="heading-subtitle" style={{ maxWidth: '900px', margin: '0 auto 2rem' }}>{pageData.intro}</p>
          <a href="https://www.onedoc.ch/fr/therapeute-en-nutrition-mco/vevey/pcyv4/zara-nawid" target="_blank" rel="noopener noreferrer" className="btn-primary">Commencer mon parcours<ArrowRight size={20} /></a>
        </div>
      </section>

      <section className="section" style={{ background: 'white' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h2 className="heading-2" style={{ marginBottom: '2rem' }}>{pageData.sections[0].title}</h2>
          <p className="body-large" style={{ marginBottom: '3rem' }}>{pageData.sections[0].content}</p>

          <h2 className="heading-2" style={{ marginBottom: '2rem' }}>{pageData.sections[1].title}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginBottom: '4rem' }}>
            {pageData.sections[1].hormones.map((hormone, i) => (
              <div key={i} style={{ background: 'var(--bg-page)', borderRadius: '1rem', padding: '1.5rem', borderLeft: '4px solid var(--accent-primary)' }}>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>{hormone.name}</h3>
                <p className="body-medium">{hormone.effect}</p>
              </div>
            ))}
          </div>

          <h2 className="heading-2" style={{ marginBottom: '2rem' }}>{pageData.sections[2].title}</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
            {pageData.sections[2].steps.map((step, i) => (
              <div key={i} style={{ background: 'white', border: '1px solid var(--border-light)', borderRadius: '1rem', padding: '2rem' }}>
                <div style={{ width: '3rem', height: '3rem', borderRadius: '50%', background: 'var(--accent-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem' }}>{i + 1}</div>
                <h3 className="heading-3" style={{ marginBottom: '1rem' }}>{step.title}</h3>
                {step.items && (
                  <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {step.items.map((item, j) => (
                      <li key={j} style={{ display: 'flex', gap: '0.5rem' }}>
                        <CheckCircle2 size={18} style={{ color: 'var(--accent-primary)', flexShrink: 0, marginTop: '0.2rem' }} />
                        <span className="body-small">{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {step.description && <p className="body-medium">{step.description}</p>}
              </div>
            ))}
          </div>

          <div style={{ background: 'var(--accent-primary-light)', borderRadius: '1rem', padding: '3rem', textAlign: 'center' }}>
            <h2 className="heading-2" style={{ marginBottom: '1.5rem' }}>Résultats attendus</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginTop: '2rem' }}>
              {pageData.sections[4].results.map((result, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textAlign: 'left' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--accent-primary)', flexShrink: 0 }} />
                  <span className="body-medium">{result}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FAQ items={faqMap['perte-poids-hormonale']} />

      <RelatedPages items={relatedPagesMap['perte-poids-hormonale']} />

      <section style={{ background: 'var(--accent-primary)', color: 'white', padding: '5rem 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '1rem' }}>{pageData.cta.title}</h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.95, maxWidth: '700px', margin: '0 auto 2.5rem' }}>{pageData.cta.text}</p>
          <a href="https://www.onedoc.ch/fr/therapeute-en-nutrition-mco/vevey/pcyv4/zara-nawid" target="_blank" rel="noopener noreferrer" className="btn-primary" style={{ background: 'white', color: 'var(--accent-primary)' }}>{pageData.cta.button}<ArrowRight size={20} /></a>
        </div>
      </section>
    </div>
  );
};

export default PertePoidsHormonale;
